import { render, staticRenderFns } from "./VuexSnackbar.vue?vue&type=template&id=7c50cad0&"
import script from "./VuexSnackbar.vue?vue&type=script&lang=js&"
export * from "./VuexSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports